/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
const initialState = {
  landingPageResult: '',
  menuList: '',
  configurationStatus: '',
  user: '',
  fromLogin: false,
};

const configuration = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'LANDING_PAGE':
      return {
        ...state,
        landingPageResult: action.response,
      };
    case 'MENU_ITEM':
      return {
        ...state,
        menuList: action.response,
      };
    case 'UPDATE_CONFIGURATION':
      return {
        ...state,
        configurationStatus: action.response.status,
        landingPageResult: action.response.data,
      };
    case 'REMOVE_CONFIG':
      return {
        ...state,
        configurationStatus: '',
      };
    case 'USER_LANDING_PAGE':
      return {
        ...state,
        user: action.response,
      };
    case 'FROM_LOGIN_LOGIN':
    case 'BACK_TO_LOGIN_STATE':
      return {
        ...state,
        fromLogin: action.response,
      };
    default:
      return state;
  }
};

export default configuration;
